import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  label1: string;
  label2: string;
  label3: string;
  value1: string | number;
  value2: string | number;
  value3: string | number;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  icon,
  title,
  label1,
  label2,
  label3,
  value1,
  value2,
  value3,
}) => {
  return (
    <Card
      style={{
        borderRadius: '8px',
        backgroundColor: '#fff',
        minWidth: 284,
        width: '100%',
        maxWidth: 370,
        height: 169,
        border: 'none',
      }}
    >
      <CardBody>
        {/* Ícone e Título */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={{ marginRight: '0.5rem', color: '#2A2C85' }}>{icon}</div>
          <h5 style={{ margin: 0, fontSize: 16, fontWeight: 500, color: '#5A5A5A' }}>{title}</h5>
        </div>

        {/* Linhas de conteúdo */}
        <Row style={{ marginBottom: '0.5rem' }}>
          <Col
            xs="6"
            style={{ textAlign: 'left', color: '#5A5A5A', fontWeight: 400, fontSize: 14 }}
          >
            {label1}
          </Col>
          <Col
            xs="6"
            style={{ textAlign: 'right', fontWeight: '700', color: '#2A2C85', fontSize: 18 }}
          >
            {value1}
          </Col>
        </Row>
        <Row style={{ marginBottom: '0.5rem' }}>
          <Col
            xs="8"
            style={{ textAlign: 'left', color: '#5A5A5A', fontWeight: 400, fontSize: 14 }}
          >
            {label2}
          </Col>
          <Col
            xs="4"
            style={{ textAlign: 'right', fontWeight: '700', color: '#2A2C85', fontSize: 18 }}
          >
            {value2}
          </Col>
        </Row>
        <Row>
          <Col
            xs="6"
            style={{ textAlign: 'left', color: '#5A5A5A', fontWeight: 400, fontSize: 14 }}
          >
            {label3}
          </Col>
          <Col
            xs="6"
            style={{ textAlign: 'right', fontWeight: '700', color: '#2A2C85', fontSize: 18 }}
          >
            {value3}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
